var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphabeticalAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.096 78c-.212 0-.42-.032-.632-.1-1.052-.352-1.604-1.492-1.252-2.532l18.868-56c.272-.82 1.04-1.368 1.9-1.368.86 0 1.612.556 1.896 1.368l18.864 56c.352 1.056-.212 2.18-1.256 2.532-1.04.352-2.18-.212-2.532-1.252L22.98 26.276 6.012 76.648c-.3.828-1.08 1.352-1.916 1.352z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.896 58h28v4h-28v-4zm84 20H53.468c-.744 0-1.416-.416-1.76-1.072-.356-.656-.3-1.444.112-2.072L88.1 21.992H59.896c-1.1 0-2-.9-2-2s.9-2 2-2h32c.744 0 1.42.416 1.764 1.072.352.664.304 1.448-.116 2.072L57.26 74h34.632c1.1 0 2 .9 2 2s-.896 2-1.996 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.896 46h-16c-1.1 0-2-.9-2-2s.9-2 2-2h16c1.1 0 2 .9 2 2s-.9 2-2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.896 55.752c-.444 0-.9-.148-1.264-.444-.852-.704-.976-1.96-.28-2.812l6.96-8.484-6.96-8.48c-.696-.856-.572-2.104.28-2.816.844-.696 2.112-.584 2.812.272l8 9.752c.604.748.604 1.8 0 2.54l-8 9.752c-.396.468-.972.72-1.548.72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabeticalAsc);
export default __webpack_public_path__ + "static/media/alphabetical-asc.9d588640d26b8face79845a7fefe4fb9.svg";
export { ForwardRef as ReactComponent };